<p>Do you want to add an Authenticator to your account?</p>

<div fxLayout="row" fxLayoutAlign="space-around">
  <button type="submit" mat-flat-button (click)="shouldAddAuthenticator.emit(false)">No</button>
  <button type="submit" mat-flat-button (click)="shouldAddAuthenticator.emit(true)">Yes</button>
</div>
